import {FETCH_GROUPS_REQUEST, CREATE_GROUP_REQUEST, UPDATE_GROUP_REQUEST, DELETE_GROUP_REQUEST} from './constants'

export function fetchGroups() {
  return {type: FETCH_GROUPS_REQUEST}
}

export function postGroup(newGroupState) {
  return {type: CREATE_GROUP_REQUEST, newGroupState}
}

export function updateGroup(updateGroupState) {
  return {type: UPDATE_GROUP_REQUEST, updateGroupState}
}

export function deleteGroup(deleteGroupState) {
  return {type: DELETE_GROUP_REQUEST, deleteGroupState}
}



// WEBPACK FOOTER //
// ./src/actions/group.js